// 如果在模块化构建系统中，请确保在开头调用了 
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 创建一个对象来保存应用启动时的初始状态
// 需要维护的状态
// state
const state = {
  searchVal: {
    // 放置初始状态 app启动的时候的全局的初始值
    "productName":"",
    "orderNo":""
  }
}
// getters
const getters = {
  productName: state => {
    // console.log('the state productName : ' + state.productName)
  }
}

// mutations
const mutations = {
  changeProductName (state) {
    state.productName = !state.productName
    // console.log('the state changeProductName : ' + state.productName)
  }
}

// actions
const actions = {
  
}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
  })


// WEBPACK FOOTER //
// ./src/store/index.js